module.exports = __webpack_public_path__ + "img/step3-main1.40c9361b.png";